export type TelegramAccountStatus = 'AUTHENTICATED' | 'UNAUTHENTICATED' | 'DISABLED' | 'UNKNOWN'

export interface TelegramAccountProps {
  id: string
  uuid: string
  phone: string
  accountID: number
  status: TelegramAccountStatus
}

export class TelegramAccountEntity {
  private readonly props: TelegramAccountProps
  private constructor(props: TelegramAccountProps) { this.props = { ...props } }
  static create(props: TelegramAccountProps) { return new TelegramAccountEntity(props) }
  get id() { return this.props.id }
  get uuid() { return this.props.uuid }
  get phone() { return this.props.phone }
  get accountID() { return this.props.accountID }
  get status() { return this.props.status }
  withStatus(status: TelegramAccountStatus) { return new TelegramAccountEntity({ ...this.props, status }) }
}
